import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import { CloudUpload, Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImgbbMigrationBanner = ({ onFinished }) => {
  const [status, setStatus] = useState(null);
  const finishedRef = useRef(onFinished);
  finishedRef.current = onFinished;

  const load = useCallback(async () => {
    const { data } = await axios.get(`${API_URL}/images/migrate-imgbb/status`);
    setStatus(prev => {
      if (prev?.state === 'running' && data.state === 'finished') finishedRef.current?.();
      return data;
    });
  }, []);

  useEffect(() => { load().catch(() => {}); }, [load]);
  useEffect(() => {
    if (status?.state !== 'running') return;
    const t = setInterval(() => load().catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [status?.state, load]);

  const start = async () => {
    await axios.post(`${API_URL}/images/migrate-imgbb`);
    setStatus({ state: 'running', done: 0, total: status?.pending || 0 });
  };

  if (!status) return null;
  const running = status.state === 'running';
  if (!running && !status.pending && status.state !== 'finished') return null;

  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4 flex flex-col md:flex-row md:items-center gap-3" data-testid="imgbb-migration-banner">
      <div className="flex-1 text-sm text-amber-900">
        {running ? (
          <p className="flex items-center gap-2" data-testid="imgbb-migration-progress">
            <Loader2 className="w-4 h-4 animate-spin" /> Transferindo imagens... {status.done || 0} de {status.total || 0}
          </p>
        ) : (
          <>
            {status.state === 'finished' && (
              <p className="flex items-center gap-2 text-green-700" data-testid="imgbb-migration-result">
                <CheckCircle2 className="w-4 h-4" /> Última transferência: {status.migrated || 0} imagem(ns) transferida(s)
                {status.failed_count ? `, ${status.failed_count} indisponível(is) no ImgBB no momento` : ''}.
              </p>
            )}
            {status.pending > 0 && (
              <p className="flex items-center gap-2 mt-1" data-testid="imgbb-migration-pending">
                <AlertTriangle className="w-4 h-4" /> {status.pending} imagem(ns) ainda dependem do ImgBB, que está instável. Transfira para o armazenamento próprio do site.
              </p>
            )}
          </>
        )}
      </div>
      {!running && status.pending > 0 && (
        <Button onClick={start} className="bg-[#003366] hover:bg-[#002244]" data-testid="imgbb-migration-start-btn">
          <CloudUpload className="w-4 h-4 mr-2" /> Transferir imagens
        </Button>
      )}
    </div>
  );
};
